module.exports = __webpack_public_path__ + "media/images-example/escuela_bv-6e728d95.jpg";